import { connect } from 'react-redux';
import PeminjamanBuku from '../../../views/Library/PeminjamanBuku/PeminjamanBuku.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(PeminjamanBuku);
